import * as React from 'react';
import { Route, Switch, useRouteMatch, useLocation } from 'react-router-dom';
import { NavigatorData, Operations } from './NavigatorData';
import JobsContent, { AllJobs, JobData, JobsRequestStatus } from './JobsContent';
import { AllJobsContentInfo } from './Paperbase';

export interface SessionJobsWrapperProps {
  jobsData: AllJobs;
  jobInfo: AllJobsContentInfo;
  jobsScope: JobsScope;
  jobsRequestStatus: JobsRequestStatus;
  handleJobsHistoryEntered?: () => void;
  handleJobClick: (row:JobData) => void;
  handleDrawerVisibilityWrapper: (jobsScope: JobsScope, close: boolean) => void;
  downloadResult: (jobData?: JobData) => void;
  initJobRequestStatus: (jobsScope: JobsScope) => void;
}

export enum JobsScope {
  Session,
  History
}


function SessionJobsWrapper(props: SessionJobsWrapperProps ) {
  let { url } = useRouteMatch();
  const { jobInfo, jobsData, handleJobClick, handleDrawerVisibilityWrapper, jobsScope, jobsRequestStatus, handleJobsHistoryEntered, downloadResult, initJobRequestStatus } = props;

  const handleDrawerVisibility = (close: boolean) => {
    handleDrawerVisibilityWrapper(jobsScope, close);
  }

  const location = useLocation();

  React.useEffect(() => {
    if (jobsScope === JobsScope.History && handleJobsHistoryEntered && location.pathname.includes(NavigatorData.jobsHistoryBaseUrl)) {
      handleJobsHistoryEntered();
    }
  }, [location]);

  React.useEffect(() => {
    initJobRequestStatus(jobsScope);
  }, [jobsScope]);

  return (
    <Switch>
      <Route path={`${url}${NavigatorData.getPathForOperation(Operations.compare)}`}>
        <JobsContent handleJobClick={handleJobClick} handleDrawerVisibility={handleDrawerVisibility} operationType={Operations.compare} jobsData={jobsData} jobInfo={jobInfo[Operations.compare]} downloadResult={downloadResult} jobsRequestStatus={jobsRequestStatus} />
      </Route>
      <Route path={`${url}${NavigatorData.getPathForOperation(Operations.twoWayMerge)}`}>
        <JobsContent handleJobClick={handleJobClick} handleDrawerVisibility={handleDrawerVisibility} operationType={Operations.twoWayMerge} jobsData={jobsData} jobInfo={jobInfo[Operations.twoWayMerge]} downloadResult={downloadResult} jobsRequestStatus={jobsRequestStatus} />
      </Route>
      <Route path={`${url}${NavigatorData.getPathForOperation(Operations.threeWayMerge)}`}>
        <JobsContent handleJobClick={handleJobClick} handleDrawerVisibility={handleDrawerVisibility} operationType={Operations.threeWayMerge} jobsData={jobsData} jobInfo={jobInfo[Operations.threeWayMerge]} downloadResult={downloadResult} jobsRequestStatus={jobsRequestStatus} />
      </Route>
      <Route path={`${url}${NavigatorData.getPathForOperation(Operations.graft)}`}>
        <JobsContent handleJobClick={handleJobClick} handleDrawerVisibility={handleDrawerVisibility} operationType={Operations.graft} jobsData={jobsData} jobInfo={jobInfo[Operations.graft]} downloadResult={downloadResult} jobsRequestStatus={jobsRequestStatus} />
      </Route>
      <Route path={`${url}${NavigatorData.getPathForOperation(Operations.patch)}`}>
        <JobsContent handleJobClick={handleJobClick} handleDrawerVisibility={handleDrawerVisibility} operationType={Operations.patch} jobsData={jobsData} jobInfo={jobInfo[Operations.patch]} downloadResult={downloadResult} jobsRequestStatus={jobsRequestStatus} />
      </Route>
      <Route path="/">
        <JobsContent handleJobClick={handleJobClick} handleDrawerVisibility={handleDrawerVisibility} operationType={Operations.compare} jobsData={jobsData} jobInfo={jobInfo[Operations.compare]} downloadResult={downloadResult} jobsRequestStatus={jobsRequestStatus} />
      </Route>
    </Switch>
  )

}

export default (SessionJobsWrapper);